import React, { useState } from "react";
import axios from "axios";
import decode from "jwt-decode";
import { connect, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import md5 from "md5";
import { LEAD_SOURCES } from "@tomocredit/common-fe/consts";
import * as actions from "state/actions/user";
import { setIdleTimer } from "state/actions/idleTimer";
import { setRoles } from "state/actions/user";
import useQueryParams from "utils/hooks/useQueryParams";
import TomoLogoBlk from "assets/tomo_logo_black.svg";
import { SignUpForm, MESSAGE_TEXT } from "./LoginHelper";

const SignUp = ({ history, setJwt, setUserId }) => {
  const queryParams = useQueryParams();
  const location = useLocation();
  const prefilledEmail = location.state?.email || "";

  const [email, setEmail] = useState(queryParams.get("email") || prefilledEmail || "");
  const [showExistingAccount, setShowExistingAccount] = useState(
    !!queryParams.get("existingAccount"),
  );
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const dispatch = useDispatch();

  const handleSuccessfulToken = (token) => {
    window.localStorage.setItem("jwt", token);
    window.localStorage.setItem("userId", email);
    setJwt(token);
    setUserId(email);
    const { roles = {} } = token ? decode(token) : {};
    dispatch(setIdleTimer(true, roles.admin));
    dispatch(setRoles(roles));
    const redirectUri = queryParams.get("redirect_uri");
    history.push(redirectUri || "/");
  };

  const performSignup = (payload) => {
    setLoading(true);
    setErrorMessage("");
    const { email: username, password, firstName, lastName } = payload;

    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/platform/signup`, {
        username: username.toLowerCase(),
        password: md5(password),
        firstName,
        lastName,
        source: LEAD_SOURCES.PLATFORM_ONBOARDING,
      })
      .then((res) => {
        // account exist?
        const { userExists, token } = res.data || {};
        if (userExists) {
          setShowExistingAccount(true);
          return;
        }
        if (token) {
          handleSuccessfulToken(token);
        }
      })
      .catch((error) => {
        const errorUserMessage = error.response?.data?.userMessage;
        if (error.response?.status === 429) {
          setErrorMessage(errorUserMessage || MESSAGE_TEXT.TOO_MANY_ATTEMPTS);
        } else {
          setErrorMessage(errorUserMessage || MESSAGE_TEXT.SERVER_ERROR);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div
      className="flex h-screen w-screen outerContainer overflow-scroll bg-neutral-50"
      style={{ letterSpacing: 0.1, minWidth: 350 }}
    >
      <div className="flex justify-center items-center w-full">
        <div
          className="w-full"
          style={{ maxWidth: 400 }}
        >
          <div className="flex justify-center items-center">
            <span className="font-extrabold text-3xl">Sign Up</span>
            <div className="border-r border-neutral-300 mx-4" style={{ width: 1, height: 31 }} />
            <span>
              <img src={TomoLogoBlk} alt="" style={{ height: 26, width: "auto" }} />
            </span>
          </div>
          <SignUpForm
            email={email}
            setEmail={setEmail}
            handleSubmit={(payload) => performSignup(payload)}
            loading={loading}
            showExistingAccount={showExistingAccount}
            setShowExistingAccount={setShowExistingAccount}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
          />
        </div>
      </div>
    </div>
  );
};

export default connect(() => ({}), actions)(SignUp);
